import {http} from 'lib/httpAxios'

export default {
  retrieveRuleList (accountCode) {
    return http.get(`/alertrules/${accountCode}`)
    .then((response) => Promise.resolve(response))
    .catch((error) => Promise.reject(error))
  },
  retrieveRuleItemTypes () {
    return http.get('/alertrules/options/appliesto')
    .then((response) => Promise.resolve(response))
    .catch((error) => Promise.reject(error))
  },
  retrieveRuleOperators () {
    return http.get('/alertrules/options/operators')
    .then((response) => Promise.resolve(response))
    .catch((error) => Promise.reject(error))
  },
  saveAlertRule (parameters) {
    let data = {
      AlertRules: []
    }
    data.AlertRules.push(parameters)
    return http.post('/alertrules', data)
    .then((response) => Promise.resolve(response))
    .catch((error) => Promise.reject(error))
  }
}



// WEBPACK FOOTER //
// ./src/vuex/api/services/rules.js